import { ReactNode } from "react";

type MainItem = {
    id: string;
    title: string;
    description: string[];
    list?: { innerTitle: string; innerDescription: string; icon: ReactNode }[];
    finalParagraph?: string;
};

export default function ContentSharedComponent({
    mainItem,
}: {
    mainItem: MainItem;
}) {
    return (
        <section className="lg:mt-12 mt-8 first-of-type:mt-0" id={mainItem.id}>
            <div className="bg-[#F6F8FB] py-4 lg:px-9 px-4">
                <h3 className="font-bold lg:text-3xl text-xl lg:leading-10 left-8">
                    {mainItem.title}
                </h3>
            </div>
            <div className="lg:mt-8 mt-4 lg:px-9 px-4">
                {mainItem.description.map((paragraph, index) => (
                    <p key={index} className="lg:mb-8 mb-4">
                        {paragraph}
                    </p>
                ))}
            </div>
            {mainItem.list && (
                <div className="lg:px-9 px-4">
                    {mainItem?.list?.map((el, index) => (
                        <div key={index} className="lg:mt-9 mt-5">
                            <div className="flex align-baseline gap-4">
                                <span>{el.icon}</span>
                                <h4 className="font-bold lg:text-lg text-base">
                                    {el.innerTitle}
                                </h4>
                            </div>
                            <p className="lg:mt-3 mt-2">
                                {el.innerDescription}
                            </p>
                        </div>
                    ))}
                </div>
            )}
            {mainItem.finalParagraph && (
                <p className="lg:px-9 px-4 lg:mt-10 mt-5">
                    {mainItem.finalParagraph}
                </p>
            )}
        </section>
    );
}
